<template>
<div class="compactMarunageForm">
  <h2 class="compactMarunageForm__title">{{ title }}</h2>
  <div class="ui big form clickable" style="position: relative;">
    <div class="ui warning message" v-if="form.hasErrors()">
      <ul class="list">
        <li v-if="form.hasError('area')">エリアを選択してください</li>
        <li v-if="form.hasError('people')">人数を選択してください</li>
        <li v-if="form.hasError('price')">一人あたりの予算を選択してください</li>
        <li v-if="form.hasError('event_date')">希望日を選択してください</li>
        <li v-if="form.hasError('event_time')">希望時間を選択してください</li>
        <li v-if="form.hasError('tel')">電話番号を半角数字のみ10桁または11桁で入力してください</li>
        <li v-if="form.hasError('email')">メールアドレスを正しく入力してください</li>
      </ul>
    </div>
    <div class="ui form">
      <div v-if="!form.model.shop_id" class="two fields compactMarunageForm__row">
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('area')}">
          <dropdown v-model="form.model.area" @change="onAreaChange()" :placeholder="'エリア(必須)'">
            <option v-for="each in consts.MARUNAGE_SHOP_AREA" :key="each.label" :value="each.value" :disabled="each.value === ''">
              {{ each.label }}
            </option>
          </dropdown>
        </div>
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('area_detail')}">
          <dropdown ref="areaDetail" v-model="form.model.area_detail" :placeholder="'エリア詳細'">
            <option value="">エリア詳細</option>
          </dropdown>
        </div>
      </div>
      <div class="two fields compactMarunageForm__row">
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('people')}">
          <dropdown v-model="form.model.people" :options="consts.MARUNAGE_PEOPLE" :placeholder="'人数(必須)'"></dropdown>
        </div>
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('price')}">
          <dropdown v-model="form.model.price" :options="consts.MARUNAGE_PRICE" :placeholder="'予算(必須)'"></dropdown>
        </div>
      </div>
      <div class="two fields compactMarunageForm__row">
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('event_date')}">
          <datepick v-model="form.model.event_date" :placeholder="'希望日(必須)'" :from="3"></datepick>
        </div>
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('event_time')}">
          <dropdown v-model="form.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'希望時間(必須)'"></dropdown>
        </div>
      </div>
      <div class="caption compactMarunageForm__caption">
        日程が確定していない場合は仮の日時をご指定いただき、希望条件欄に大体の開催時期をご記載ください
      </div>
      <div v-if="!userId" class="field compactMarunageForm__row" :class="{'error': form.hasError('email')}">
        <input type="text" v-model="form.model.email" :placeholder="'ご連絡先メールアドレス(必須)'" />
      </div>
      <div v-if="!hasTel" class="field compactMarunageForm__row" :class="{'error': form.hasError('tel')}">
        <input type="text" v-model="form.model.tel" :placeholder="'ご連絡先電話番号(必須)'" />
      </div>
      <div class="field compactMarunageForm__row" :class="{'error': form.hasError('note')}">
        <textarea rows="2" v-model="form.model.note" placeholder="希望条件があればご記入ください。"></textarea>
      </div>
      <app-message :msg="form.appMessage"></app-message>
      <div class="field">
        <button @click="marunage" class="ui fluid orange button large compactMarunageForm__btn" :class="{'disabled loading': form.waiting}">{{ actionLabel }}</button>
      </div>
    </div>
    <div id="detailed-marunage-form-dialog" class="ui modal">
      <i class="close icon"></i>
      <div class="scrolling content">
        <detailed-marunage-form :form-name-prefix="formNamePrefix" action-label="送信する"></detailed-marunage-form>
      </div>
    </div>
    <a @click.prevent="openDialog" class="compactMarunageForm__clickArea"></a>
  </div>
</div>
</template>

<script>
import DetailedMarunageForm from './detailedMarunageForm.vue';

export default {
    components: {
      DetailedMarunageForm: DetailedMarunageForm
    },
    props: {
        title: {
            required: false,
            type: String,
            default: '完全無料！カンタン60秒でスピード依頼'
        },
        actionLabel: {
            required: false,
            type: String,
            default: '宴会コンシェルジュに会場を探してもらう'
        },
        shopId: {
            required: false,
            type: Number
        },
        area: {
            required: false,
            type: [Number, String]
        },
        areaDetail: {
            required: false,
            type: [Number, String]
        },
        formNamePrefix: {
            required: false,
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            form: this.createForm({
                area_detail: null
            }),
            hasTel: false,
            isBulk: false
        };
    },
    created: function() {
        // ログイン済みの場合は下記データはログイン情報を利用するのでダミーデータを入れておく
        if (this.userId && this.userRole === '') {
            this.createForm().get('/api/member/profile', function(response) {
                this.form.model.email = response.data.user.login_id;
                this.form.model.tel = response.data.tel;
                if (this.form.model.tel) {
                    this.hasTel = true;
                }
            });
        }

        this.extendModel({
          shop_id: this.shopId,
          area: this.area,
          area_detail: this.areaDetail
        });
    },
    methods: {
        openDialog: function() {
            $('#detailed-marunage-form-dialog').modal({autofocus: false}).modal('show');
        },
        extendModel: function(model) {
            _.extend(this.form.model, model);
        },
        bulk: function() {
            this.isBulk = true;
        },
        onAreaChange: function() {
            this.form.model.area_detail = null;
            this.$refs.areaDetail.setOptions(this.areaDetailsOf(this.form.model.area));
        },
        marunage: function() {
            var category = 'まるなげ';
            if (this.form.model.shop_id) {
                category = '直予約';
            } else if (this.isBulk) {
                category = '一括問合せ';
            }
            if (this.isBulk) {
                this.form.model.shop_ids = this.selectedShops();
            }
            this.form.post('/api/marunages', function(response) {
                if (this.isBulk) {
                    this.setShops([]);
                }
                this.pushDataLayer({
                    'category': category,
                    'result': true,
                    'eventCallback': function() {
                        document.location = response.data.chat_url + '&opened=true';
                    }.bind(this)
                });
            }, function() {
                this.pushDataLayer({
                    'category': category,
                    'result': false
                });
            });
        }
    },
    computed: {
        redirectToCurrentLocationQuery: function() {
            return 'redirect=' + window.encodeURIComponent(window.location.pathname + window.location.hash);
        }
    }
};
</script>
